import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import Vuetify from 'vuetify'
import '@components/_globals'
import VueSweetalert2 from 'vue-sweetalert2'

import * as Sentry from '@sentry/browser'

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (window.Cypress) {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Sentry.init({
  dsn: 'https://48cd84f0480e4fa4aa689aa6d99316b8@sentry.io/1339758',
  integrations: [new Sentry.Integrations.Vue({ Vue })],
})

const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674',
}

Vue.use(VueSweetalert2, options)
Vue.use(require('vue-moment'))
Vue.use(Vuetify, {
  iconfont: 'mdi', // 'md' || 'mdi' || 'fa' || 'fa4'
})

const app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

// If running inside Cypress...
if (window.Cypress) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
